/**
 * What a shopper is told about the reveal-then-claim hold (the rule is in
 * `storefrontCopy/shared.ts`): a revealed item's price is held out of the spendable balance until
 * it is claimed. Platform words, the same on every store apart from its terms, so never a store's
 * copy.
 */
import type { StorefrontTerminology } from "./storefrontTerminology.js";

/**
 * Under a balance while some of it is held, given the held amount formatted: the account header's
 * and Add funds'.
 */
export function heldForRevealsLine(amount: string, terms: StorefrontTerminology): string {
  return `${amount} held for ${terms.item.plural} you have revealed but not claimed yet.`;
}

/** Battle create's spendable balance, and what an unclaimed reveal holds of it, both formatted. */
export function spendableBalanceLine({
  spendable,
  held,
}: {
  spendable: string;
  held: string | null;
}): string {
  return `Spendable: ${spendable}${held !== null ? ` (${held} held for an unclaimed reveal)` : ""}`;
}
